import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

import TitleFlow from '../titleFlow/';
import ActivityPic from '../activityPic/';

class ActivityArea extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const { pic, list } = content;

        return (
            <div className={styles.activityArea}>
                <Chip id="50116" type="struct" title="活动专区大图" groupName="财经研究院首页" content={pic}>
                    <ActivityPic />
                </Chip>
                <ul className={styles.activityList}>
                    <Chip id="50133" type="struct" title="活动专区列表" groupName="财经研究院首页" content={list}>
                        <TitleFlow />
                    </Chip>
                </ul>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
ActivityArea.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
ActivityArea.defaultProps = {};

export default ActivityArea;
